'use strict';

import * as THREE from 'three';
import TWEEN from '../js/libs/tween.umd';

import {
    Buildings,
    cardsData,
    isMobile,
    projectMode,
    settingsData,
    threeJsVariables,
} from './settings';
import { add_tween_animation, animateCamera } from './modules/threejs/animation';
import {CardTypes, ViewMode} from "./common";
import {removeSearchContainer} from "./modules/search/search";

import {
    enableOrbitControls, enableTrackballControls,
    getCurrentCameraDistance,
    getWorldData,
} from './modules/controls/orbitControls';
import {updateRenderer} from "./app";
import {changeLangToCurrent} from "./modules/language/langSwitcher";
import {mobileBurgerStyleToggle} from "./modules/menu/menu";
import {Vector3} from 'three';

import {openOptionsCard} from "./modules/cards/optionsCards";
import {similarFavoriteHandle} from "./modules/search/similarSearch";
import {analytics} from "./modules/analytics/analytics";
import {UnitCardClass} from "./modules/cards/unitCards/UnitCardClass";
import { setLordIcon } from './lordicon';
import {selectionBoxesSetStatusColor} from "./modules/threejs/raycast";
import { Spherical } from 'three';
import { mapElementStyleToggle } from './modules/widgets/poi/poiv3';
import gsap from 'gsap';
import { OutlineEdges } from './libs/outlineEdges/OutlineEdges';

export function restrictUserInteractions(action) {
    action = !!action;

    enableTrackballControls(!action);
    enableOrbitControls(!action);
    userPrevent(action);
}

export async function flatClick(apartment, settings, isCardClose) {
    if (settingsData.bombBlock && !settingsData.doubleClick) return;
    if (userPrevent()) return;

    /**
     * block if exact card has already opened
     */

    // const openedCard = UnitCardClass.findCard(apartment.userData.crm_data.engineId);
    let openedCard;
    if (projectMode.LiteMode.modeIs('picture')) {
        openedCard = UnitCardClass.findCard(apartment.engineId);
    } else {
        openedCard = UnitCardClass.findCard(apartment.userData.crm_data.engineId);
    }

    if (openedCard) {
        // settingsData.doubleClick = false;
        if (settingsData.doubleClick && apartment === settingsData.selectedObject) {
            !document.querySelector(`.${CardTypes.Options}-card`) && openOptionsCard();
        }

        return;
    }

    // const floorIndex = apartment.userData.floor;
    let floorIndex;
    if (projectMode.LiteMode.modeIs('picture')) {
        floorIndex = apartment.floorNum;
    } else {
        floorIndex = apartment.userData.floor;
    }
    cardsData.cardMode.isAmenities = apartment.userData?.customSelection;

    /**
     * rotation building animation / building destroy logic
     */

    if (!projectMode.LiteMode.modeIs('picture')) {
        if (!settingsData.buildingDestroyed) {
            rotation_to_flat(apartment);
        } else {
           await moveAroundTheFloors(apartment.userData.crm_data.engineId);
        }
    }

    settingsData.currentFloor = !cardsData.cardMode.isAmenities ? floorIndex : 0;

    /**
     * return, when close one of cards, when building destroyed (no necessary to open new card)
     */
    if (isCardClose) return;

    /**
     *  open cards
     */
    // setTimeout(() => {
        if (cardsData.cardMode.isAmenities) {
            UnitCardClass.closeMultipleCards();
            openOptionsCard();
        } else if (!apartment?.userData?.buildingFloors) {
            if (settingsData.doubleClick) {
                !document.querySelector(`.${CardTypes.Options}-card`) && openOptionsCard();
            }

            if (projectMode.LiteMode.modeIs('picture')) {
                UnitCardClass.cards.push(new UnitCardClass(apartment));
            } else {
                UnitCardClass.cards.push(new UnitCardClass(apartment.userData.crm_data));
            }

            let currentCard;
            if (projectMode.LiteMode.modeIs('picture')) {
                currentCard = UnitCardClass.cards.find(card => card.engineId === apartment.engineId);
            } else {
                currentCard = UnitCardClass.cards.find(card => card.engineId === apartment.userData.crm_data.engineId);
            }

            currentCard.createCard();

        }
    // }, 200);
}

export function lazyLoadingData(loader, url) {
    return new Promise((res, rej) => {
        loader.load(url, loadData => {
            res(loadData);
        },undefined,(err)=>{
            settingsData.loadingError = true;
            rej(err);
        });
    });
}

export function lazyLoadingAll(promises) {
    return Promise.all(promises);
}

export function setColorsKeyPlan(currentFloorIndex = null) {
    const activeBuilding = Buildings.getActiveBuilding();

    for (const apt of activeBuilding.apartments) {
        const isFirstFloor = currentFloorIndex === 0 && apt.userData.floor === 0;

        if (apt.userData.isInSearch) continue;

        if (isFirstFloor || currentFloorIndex && apt.userData.floor === currentFloorIndex) {
            selectionBoxesSetStatusColor(apt, 'lock');
        } else {
            const searchIsOpen = document.querySelector('.search__container-main');


            if (!searchIsOpen || !apt.userData.isInSearch) {
                selectionBoxesSetStatusColor(apt, 'unlock');
            }
        }

        apt.userData.isClicked && selectionBoxesSetStatusColor(apt, 'click');
    }
}

export function isMobileApple() {
    const isAppleMobile = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
    if (isAppleMobile) {
        return true;
    } else {
        const macTouchOrDesktop = /Macintosh/.test(window.navigator.userAgent);

        return !!(macTouchOrDesktop && window.navigator.maxTouchPoints);
    }
}

export function isPortraitMode() {
    return window.matchMedia("(orientation: portrait)").matches;
}

export function detectMobile() {
    let t = getUrlParam('type')
    if (t === 'android' || t === 'ios') {
        return true
    } else {
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {

            return true;

        }
        // return window.innerWidth <= 490 && window.innerHeight <= 926 || window.innerWidth <= 926 && window.innerHeight <= 450;
    }
    return false;
    // isMobile = false;
    return false;
    // const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // const testDevice = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
    // return testDevice;
    // return isMobile;
}

export function numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function object_disappear(object, duration = 1000, delay = 0, easing = TWEEN.Easing.Linear.None) {
    if (object.children.length > 0) {
        object.children.forEach(function (children) {
            object_disappear(children, duration, delay, easing);
        });
    } else {
        let object_materials = object.material;
        if (Array.isArray(object_materials)) {
            object_materials.forEach(function (material) {
                material_disappear(material, duration, delay, easing);
            });
        } else {
            material_disappear(object_materials, duration, delay, easing);
        }
    }
    setTimeout(function () {
        object.visible = false;
    }, duration);
}

export function object_appear(object, duration = 1000, delay = 0, easing = TWEEN.Easing.Linear.None) {
    object.visible = true;
    if (object.children.length > 0) {
        object.children.forEach(function (children) {
            object_appear(children, duration, delay, easing);
        });

    } else {
        let object_materials = object.material;
        if (Array.isArray(object_materials)) {
            object_materials.forEach(function (material) {
                material_appear(material, duration, delay, easing);
            });
        } else {
            material_appear(object_materials, duration, delay, easing);
        }
    }
}

function material_disappear(material, duration, delay, easing) {
    material.transparent = true;
    if (!material.userData.base_opacity) {
        material.userData.base_opacity = material.opacity;
    }

    add_tween_animation({
        'animation_obj': settingsData.tween_animations,
        'start': {
            opacity: material.opacity
        },
        'target': {
            opacity: 0
        },
        'duration': duration,
        'easing': easing,
        'delay': delay
    }, function (e) {
        material.opacity = e.opacity;
    }, function (e) {
        material.opacity = 0;
    }, () => {
    });
}

function material_appear(material, duration, delay, easing) {
    material.transparent = true;
    add_tween_animation({
        'animation_obj': settingsData.tween_animations,
        'start': {
            opacity: material.opacity
        },
        'target': {
            opacity: material.userData.base_opacity
        },
        'duration': duration,
        'easing': easing,
        'delay': delay
    }, function (e) {
        material.opacity = e.opacity;
    }, function (e) {
        material.opacity = material.userData.base_opacity;
        // rendererAnimationPause(true);
    }, () => {
        // rendererAnimationPause(false)
    });
}

export function get_url_param(name) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams) {
        let param = urlParams.get(name);
        if (param !== null) {
            return param;
        } else {
            return false;
        }
    }
}

export function createElements(tag, classNames, parent, position = 'beforeend', customAttr) {
    if (!position) position = 'beforeend';

    const element = document.createElement(tag);

    if (classNames) classNames.forEach(classItem => element.classList.add(classItem));
    if (tag === 'button') element.setAttribute('type', 'button');
    if (customAttr) element.setAttribute(customAttr.data, customAttr.value);

    if (parent) {
        parent.insertAdjacentElement(position, element);
    }
    return element;
}

export function createHtmlElement(parent, elementName, elementTag, elementClass) {
    const el = document.createElement(elementTag);
    if (Array.isArray(elementClass)) {
        elementClass.forEach(classElement => {
            el.classList.add(classElement);
        });
    } else {
        el.style.cssText = elementClass;
    }
    el.innerHTML = elementName;
    if (parent) {
        parent.appendChild(el);
    }
    return el;
}

export function rotation_to_flat(apartment) {
    const {orbitControlsVector,flatVector,floorVector} = getWorldData(apartment);
    const directionVector = new Vector3().subVectors(flatVector,orbitControlsVector).normalize();
    const spherical = new Spherical().setFromVector3(directionVector);

    const from = threeJsVariables.orbitControls.getAzimuthalAngle();
    const to = spherical.theta;

    const tempD = to - from;

    let delta;

    if (tempD < 0 && tempD < -Math.PI) {
        delta = tempD + 2 * Math.PI;
    } else if (tempD > 0 && tempD > Math.PI) {
        delta = tempD - 2 * Math.PI;
    } else {
        delta = tempD;
    }

    threeJsVariables.orbitControls.setAzimuthDeltaAngle(delta);

    return delta;

    // console.log('rotation_to_flat');
    // const {cameraVector, orbitControlsVector, floorVector, flatVector} = getWorldData(apartment);
    // const currentDistance = getCurrentCameraDistance();
    //
    // let aptTarget;
    //
    // if (isMobile) {
    //     aptTarget = new Vector3(orbitControlsVector.x, flatVector.y - 15, orbitControlsVector.z);
    // } else {
    //     aptTarget = new Vector3(orbitControlsVector.x, orbitControlsVector.y, orbitControlsVector.z);
    // }
    //
    // const aptPosition = new Vector3(flatVector.x, flatVector.y - 15, flatVector.z);
    //
    // const directionFloorAndApt = new Vector3();
    // directionFloorAndApt.subVectors(aptPosition, orbitControlsVector).normalize().setLength(currentDistance).add(aptTarget);
    //
    // animateCamera(
    //     cameraVector,
    //     directionFloorAndApt,
    //     orbitControlsVector,
    //     aptTarget,
    //     undefined,
    //     currentDistance,
    //     undefined,
    //     undefined,
    //     1000,
    //     TWEEN.Easing.Sinusoidal.InOut,
    //     () => {
    //     },
    //     () => {
    //         // setMinAndMaxControlsDistance();
    //         threeJsVariables.orbitControls.saveState();
    //         // showOrHideCylinderFloorNumbers();
    //     }
    // );
}

export function enableSwitcherBtns(action) {
    const nav_btns = document.querySelectorAll('#building-switcher .new-ui-direction-btn');
    if (nav_btns.length > 0) {
        nav_btns.forEach(switcherBtn => {
            if (action) {
                switcherBtn.removeAttribute('disabled');
            } else {
                switcherBtn.setAttribute('disabled', 'true');
            }
        });
    }
}

export function getUrlParam(name, desktop) {
    const url = new URL(window.location.href);
    const searchParam = url.searchParams.get(name);

    // console.log(url, searchParam)
    // if (desktop){
    //     const propNum = parseInt(url.split('/'));
    //     console.log(propNum);
    // }

    return searchParam;
}

export function createMaterialAndSetBaseColor(apartment) {

    if (projectMode.LiteMode.isActive() && !projectMode.LiteMode.modeIs('regular')) {
        apartment.material = new THREE.MeshPhongMaterial({
            color: '#0d61af',
            transparent: false,
            opacity: 1.0,
            depthWrite: true,
            depthTest: true,
        });

        new OutlineEdges(apartment,{
            color: '0x000000'
        });

    } else {

        apartment.material = new THREE.MeshBasicMaterial({
            color: '#0d61af',
            transparent: true,
            opacity: 0,
            depthWrite: false,
            depthTest: true,
        });

    }

    // apartment.material = new THREE.MeshBasicMaterial({
    //     color: '#0d61af',
    //     transparent: true,
    //     opacity: 0,
    //     depthWrite: false,
    //     depthTest: true,
    // });

}

export function removeSelectionBoxesLockColor(building) {
    if (!building) {
        building = Buildings.getActiveBuilding();
    }

    const apartmentWithAmenities = building?.apartments.concat(building.customSelections);

    if (building?.apartments?.length > 0) {
        apartmentWithAmenities.forEach(item => {
            item.userData.isActive = false;
            item.userData.isInSearch = false;
            item.userData.isClicked = false;
            selectionBoxesSetStatusColor(item, 'unlock');
        });
    }
}

export function userPrevent(value = undefined) {
    if (value !== undefined) {
        settingsData.userPrevent = value;
    } else {
        return settingsData.userPrevent;
    }
}

export const changeBorderRadius = (element) => {
    const root = document.querySelector(':root');
    const borderShape = root.style.getPropertyValue('--buttonShape');
    if (borderShape === 'var(--roundedCorners)') {
        // element.style.borderRadius = '30px';
        root.style.setProperty('--specificRoundedCorners', '30px');
    }
    // console.log(element)
    if (element.classList.contains('nmf-range-selector') && borderShape === 'var(--roundedCorners)') {
        root.style.setProperty('--specificBorder', '3px');
    }

    if (element.classList.contains(`${CardTypes.Options}-card__plans-box_disclaimer-opacity`) && borderShape === 'var(--roundedCorners)') {
        root.style.setProperty('--specificBorderForDisclaimer', '4px');
    }
}

// export function changeShadowsOptions(activeTower, action) {
//     const building = threeJsVariables.scene.getObjectByName(activeTower.name);
//
//     building.traverse(element => {
//         if (element.isMesh && element.name !== 'Ground_instance') {
//             element.receiveShadow = action;
//         }
//     });
// }

/**
 * Header for menu (mobile mode)
 **/

export const addHeader = (parent, title) => {
    parent.childNodes.forEach(elem => {
        if (elem === document.querySelector('.widget__container-title')) return;
    })

    const titleBlock = createElements('h2', ['widget__container-title', 'language-string'], parent, 'afterbegin', {
        data: 'data-dictionary',
        value: title
    });

    titleBlock.innerHTML = changeLangToCurrent(title);
}

export const addCloseBtn = (parent) => {
    const isCloseBtnExist = parent.querySelector('.widget__container-close');
    if (isCloseBtnExist) return;

    const closeButton = createElements('button', ['widget__container-close', 'icon-right'], parent, 'afterbegin');
    closeButton.addEventListener('click', () => {
        projectMode.Pagination.paginate({source: 'widget-close-button'});
        if (isMobile && document.querySelector('.additional-menu__container')) {
            const menuItems = document.querySelectorAll('.additional-menu__item');
            menuItems.forEach(item => {
                if (item.classList.contains('additional-menu__active')) {
                    item.classList.remove('additional-menu__active');
                } else {
                    if (settingsData.activeViewMode === ViewMode.Orbit) {
                        if (item.getAttribute('data-menu-item') === '3dModel' && !item.classList.contains('additional-menu__active')) {
                            item.classList.add('additional-menu__active');
                        }
                    } else {
                        if (item.classList.contains('additional-menu__search') && !item.classList.contains('additional-menu__active')) {
                            item.classList.add('additional-menu__active');
                        }
                    }
                }
            });
        }

        if (parent.classList.contains("search__container-main")) {
            removeSearchContainer();
            return;
        }
        parent.classList.remove('show-page');
        settingsData.stopRender = false;
        updateRenderer();
        mobileBurgerStyleToggle();
        mapElementStyleToggle(parent);
    });
}

export class Drag {
    constructor(element, parameters = {}) {
        this.element = typeof (element) === 'string' ? document.querySelector(element) : element;
        this.active = false;
        this.currentX = null;
        this.currentY = null;
        this.initialX = null;
        this.initialY = null;
        this.xOffset = 0;
        this.yOffset = 0;
        this.touchSupport = parameters.hasOwnProperty('touchSupport') ? parameters['touchSupport'] : false;
        this.updateElementPositionAfterDragEnd = parameters.hasOwnProperty('updateElementPositionAfterDragEnd') ? parameters['updateElementPositionAfterDragEnd'] : false;

        this.element.style.cursor = 'grab';

        this.element.addEventListener('mousedown', function (evt) {
            this.dragStart(evt);
        }.bind(this), false);

        if (this.touchSupport) {
            this.element.addEventListener('touchstart', function (evt) {
                this.dragStart(evt);
            }.bind(this), false);
        }
    }

    dragStart(evt) {
        this.element.style.cursor = 'grabbing';
        if (evt.type === 'touchstart' && this.touchSupport) {
            this.initialX = evt.touches[0].clientX - this.xOffset;
            this.initialY = evt.touches[0].clientY - this.yOffset;
            this.clickX = evt.touches[0].clientX;
            this.clickY = evt.touches[0].clientY;
            this.active = true;

            document.ontouchmove = (evt) => this.dragMove(evt);
            this.element.ontouchend = (evt) => this.dragUp(evt);

        } else {
            this.initialX = evt.clientX - this.xOffset;
            this.initialY = evt.clientY - this.yOffset;
            this.clickX = evt.clientX;
            this.clickY = evt.clientY;
            this.active = true;

            document.onmousemove = (evt) => this.dragMove(evt);
            this.element.onmouseup = (evt) => this.dragUp(evt);
        }
    }

    dragMove(evt) {
        if (this.active) {
            if (evt.type === 'touchmove' && this.touchSupport) {
                this.currentX = evt.touches[0].clientX - this.initialX;
                this.currentY = evt.touches[0].clientY - this.initialY;
            } else {
                this.currentX = evt.clientX - this.initialX;
                this.currentY = evt.clientY - this.initialY;
            }

            this.xOffset = this.currentX;
            this.yOffset = this.currentY;

            if (this.element.style.animation) {
                this.element.style.animation = '';
            }

            this.element.style.transform = "translate3d(" + this.currentX + "px, " + this.currentY + "px, 0)";

            for (let child of this.element.children) {
                child.style.userSelect = 'none';
                child.style.pointerEvents = 'none';
            }
        }
    }

    dragUp(evt) {
        this.element.style.cursor = 'grab';
        this.initialX = this.currentX;
        this.initialY = this.currentY;
        this.active = false;

        for (let child of this.element.children) {
            child.style.userSelect = '';
            child.style.pointerEvents = '';
        }

        if (this.updateElementPositionAfterDragEnd) {
            this.element.style.left = parseFloat(this.element.style.left) + this.xOffset + 'px';
            this.element.style.top = parseFloat(this.element.style.top) + this.yOffset + 'px';
            this.element.style.transform = '';
            this.xOffset = 0;
            this.yOffset = 0;
        }

        this.removeEventListeners();
    }

    removeEventListeners() {
        this.element.ontouchend = null;
        this.element.onmouseup = null;
        document.onmousemove = null;
        document.ontouchmove = null;
    }

}

export const removePropParam = () => {
    const prop = getUrlParam('prop');
    if (!prop) return;

    const refresh = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.replaceState({path: refresh}, '', refresh);
}

export const lockScreenForTablet = () => {
    if (document.querySelector('.tablet-plug')) return;

    const titleText = 'For maximum experience please rotate your device to landscape';
    const subTitleText = 'if screen does not rotate, make sure your screen orientation is unlocked';

    const container = createElements('div', ['tablet-plug', 'non-canvas'], document.body);

    setLordIcon('rotate',container,{
        stroke: '100'
    });

    const title = createElements('div', ['tablet-plug__title', 'language-string'], container);
    const subtitle = createElements('div', ['tablet-plug__subtitle', 'language-string'], container);

    title.setAttribute('data-dictionary', titleText);
    subtitle.setAttribute('data-dictionary', subTitleText);

    title.innerHTML = changeLangToCurrent(titleText);
    subtitle.innerHTML = changeLangToCurrent(subTitleText);
}

export const findSelectionAndCrmData = (engineId) => {
    const towerName = engineId.split('_')[0];

    let activeTower;
    let selectedMesh;
    let crmDataOfFlat;

    // const activeTower = buildings_info.find(building => building.name === towerName);
    if (projectMode.LiteMode.modeIs('picture')) {
        activeTower = Buildings.getBuilding(towerName);
        crmDataOfFlat = selectedMesh = activeTower.info.crm_data.find(flat => flat.engineId === engineId);
    } else {
        activeTower = Buildings.getBuilding(towerName);
        selectedMesh = activeTower.apartments.find(flat => flat.name === engineId);
        crmDataOfFlat = selectedMesh.userData.crm_data;
    }

    return {activeTower, selectedMesh, crmDataOfFlat};
}

/**
 * ADD TO FAVORITES
 */
export const handleFavoriteLogic = (e, action) => {
    if (e?.target?.classList.contains('similar-apt-card__favorite-label') || (e?.target?.tagName === 'LORD-ICON') && e?.target?.parentElement.classList.contains('similar-apt-card__favorite-label')) {
        similarFavoriteHandle(e);
        return;
    }


    let activeUnitCard = UnitCardClass.findCard(false, 'active')?.html;

    if (!cardsData.multiplyCards) {
        activeUnitCard = UnitCardClass.findCard()?.html;
    }

    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);

    let data;

    if (e.target.closest('.search__result-item')) {
        data = findSelectionAndCrmData(e.target.closest('.search__result-item').getAttribute('data-engineid'));
    } else if (e.target.closest(`.${CardTypes.Unit}-card`)) {
        data = findSelectionAndCrmData(e.target.closest(`.${CardTypes.Unit}-card`).getAttribute('data-engineid'));
    } else if (e.target.closest(`.${CardTypes.Options}-card`)) {
        data = findSelectionAndCrmData(e.target.closest(`.${CardTypes.Options}-card`).getAttribute('data-engineid'));
    }

    let storageData = getObjectFromLocalStorage(data.crmDataOfFlat.engineId);

    switch (action) {
        case ('searchClick'):
            e.target.classList.toggle('icon-favorite_selected');
            e.target.classList.toggle('icon-unselected');

            if (!storageData) {
                addObjectToLocalStorage(data.crmDataOfFlat);
            } else {
                removeObjectFromLocalStorage(data.crmDataOfFlat);
            }

            if (activeUnitCard) {
                const currentCard = UnitCardClass.findCard(data.crmDataOfFlat.engineId)?.html;
                // if (!currentCard) return;
                if (currentCard){
                    const unitFavoriteLabel = currentCard.querySelector(`.${CardTypes.Unit}-card__favorite-label`);

                    unitFavoriteLabel.classList.toggle('icon-favorite_selected');
                    unitFavoriteLabel.classList.toggle('icon--lord-unselected');
                }
            }
            break
        case ('cardClick'):
            const currentCard = UnitCardClass.findCard(data.crmDataOfFlat.engineId)?.html;

            if (currentCard) {
                const label = currentCard.querySelector(`.${CardTypes.Unit}-card__favorite-label`);

                label.classList.toggle('icon-favorite_selected');
                label.classList.toggle('icon--lord-unselected');
            }

            const searchItemLabel = document.querySelector(`.search__result-item[data-engineid=${data.crmDataOfFlat.engineId}] span[data-favorite=favorite]`);

            if (searchItemLabel) {
                searchItemLabel.classList.toggle('icon-favorite_selected');
                searchItemLabel.classList.toggle('icon-unselected');
            }

            if (!storageData) {
                addObjectToLocalStorage(data.crmDataOfFlat);
            } else {
                removeObjectFromLocalStorage(data.crmDataOfFlat);
            }

            if (optionsCard) {
                const currentOptionsCard = document.querySelector(`.${CardTypes.Options}-card[data-engineid=${data.crmDataOfFlat.engineId}]`);

                const optionsCardLabel = currentOptionsCard.querySelector(`.${CardTypes.Options}-card__favorite-label`);

                optionsCardLabel.classList.toggle('icon-favorite_selected');
                optionsCardLabel.classList.toggle('icon--lord-unselected');
            }
            break;
    }

    const crmDataOfFlat = data.crmDataOfFlat;
    analytics('favorites', {storageData, crmDataOfFlat});
}

//START Local storage handler

export const addObjectToLocalStorage = (apartment) => {
    const favorites = localStorage.getItem('favorites');

    if (favorites?.length > 0) {
        localStorage.setItem('favorites', JSON.stringify([...JSON.parse(favorites), apartment]));
    } else {
        localStorage.setItem('favorites', JSON.stringify([apartment]));
    }
}

export const removeObjectFromLocalStorage = (apartment) => {
    let storageData = JSON.parse(localStorage.getItem('favorites'));
    if (!storageData) return;

    const favorites = storageData.filter(elem => elem.engineId !== apartment.engineId).flat();
    localStorage.setItem('favorites', JSON.stringify(favorites));
}

export function getObjectFromLocalStorage(engineId) {

    if (settingsData.lastClickedFlat?.userData?.customSelection) return;

    let storageData = JSON.parse(localStorage.getItem('favorites'));
    return storageData ? storageData.find(elem => elem.engineId === engineId) : null;
}

export const moveAroundTheFloors = async (engineId) => {

    if (!settingsData.buildingDestroyed) return;
    const {selectedMesh} = findSelectionAndCrmData(engineId);
    const selectedFloor = selectedMesh.userData.floor;

    let timeOut = 0;

    if (settingsData.currentFloor > selectedFloor) {
        await projectMode.FloorPlan.down(selectedFloor,selectedMesh);
        // setColorsKeyPlan(selectedFloor);
        // // settingsData.currentFloor = selectedFloor;
        // destroyBuilding(selectedFloor);
        // actionForFirstAndLastFloors(selectedFloor);
        // flatLabelsUpdate(selectedFloor);
        // changeSliderActiveBtn(selectedFloor);

    } else if (settingsData.currentFloor < selectedFloor) {

       await projectMode.FloorPlan.up(selectedFloor,selectedMesh);

        // const {flatVector} = getWorldData(selectedMesh);
        // const target = new Vector3(flatVector.x, selectedMesh.userData.baseWorldPosition.y, flatVector.z);
        //
        // floorMoveAnimation(settingsData.currentFloor, 'appear', selectedFloor);
        // destroyCameraAnimation(target, 'appear', selectedMesh);
        // setColorsKeyPlan(selectedFloor);
        // // flatLabelsUpdate(settingsData.currentFloor);
        // // flatLabelsUpdate(selectedFloor);
        // changeSliderActiveBtn(selectedFloor);
        // actionForFirstAndLastFloors(settingsData.currentFloor)
        // // actionForFirstAndLastFloors(selectedFloor)
        // timeOut = 1500;
        //
        // setTimeout(() => {
        //     flatLabelsUpdate(selectedFloor);
        // }, timeOut);

    } else {
        // !settingsData.switchLang && setTimeout(() => rotation_to_flat(selectedMesh), timeOut);
        rotation_to_flat(selectedMesh);
    }
}

export function rgbaToHexA(rgbaArray, addAlphaChanel = true) {
    let r = (+rgbaArray[0]).toString(16),
        g = (+rgbaArray[1]).toString(16),
        b = (+rgbaArray[2]).toString(16),
        a = Math.round(+rgbaArray[3] * 255).toString(16);

    if (r.length == 1)
        r = '0' + r;
    if (g.length == 1)
        g = '0' + g;
    if (b.length == 1)
        b = '0' + b;
    if (a.length == 1)
        a = '0' + a;

    if (addAlphaChanel) {
        return '#' + r + g + b + a;
    } else {
        return '#' + r + g + b;
    }
}